import React from 'react'
import { FlipBox } from '../components/FlipBox'

const host = REST_API// "http://localhost:8080"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
const baseUrl = host + "/api/files"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
import { Flag } from '../../../appcraft-forms/src/components/Flag'


// /uploads/2016/07/Flag_Icon_FR.png
// const languageName = {
//   FR: "Français",
//   EN: "Anglais"
// }

    // <img className="size-full wp-image-1840 alignnone" src={`http://www.cyrillejoubert-talents.com/wp-content/uploads/2016/07/Flag_Icon_${lang}.png`} width="24" height="14" />

function cleanLevel(level){
  if (!level) return ''
  else if ((typeof level) === "string") return '(' + level + ')'
  else if (level.label) return '(' + level.label + ')'
  else return ''
}

export const Language = ({lang, label, level}) => (
  <div style={{ textAlign: 'left', fontWeight: 300, paddingTop: 2, paddingBottom: 2 }}>
    <Flag code={lang} 
          style={{
            zoom: 0.75,
            MozTransform:'scale(0.75)',
            MozTransformOrigin: '0 0', 
            display: 'inline-block', 
            margin: 0, 
            verticalAlign: 'middle'}}/>
      &nbsp;&nbsp;<span style={{verticalAlign: 'middle'}}>{label}</span>
      &nbsp;<span style={{verticalAlign: 'middle'}}>{cleanLevel(level)}</span>
  </div>
)

function ensureAgent(agents){
  if (!agents || agents.length == 0) {
    return {
      "name":"Cyrille Joubert",
      "mail":"castingcyril@gmail.com",
      "phone":"+33 6 62 63 47 24"
    }
  }
  return agents[0]
}

export const Agents = ({agents, isPDF=false}) => {
  const agent = ensureAgent(agents)
  return (
    <div style={{height: 220, overflow: isPDF ? 'hidden' : undefined}}>
      <FlipBox 
        showBack={isPDF}
        front={
          <div style={{ verticalAlign: 'middle', display: 'table-cell', height: '100%', width: '100%' }}>
            <h2 style={{ color: '#ffffff', margin: 0 }} data-fontsize="20" data-lineheight="25">CONTACT AGENT</h2>
          </div>
        }
        back={
          <div style={{ verticalAlign: 'middle', display: 'table-cell', height: '100%', width: '100%' }}>
            <h3 style={{ color: '#ffffff', marginTop: 0}}>Contact</h3>
            <p style={{ textAlign: 'center' }}><strong>Agent: </strong> {agent.name}</p>
            <p style={{ textAlign: 'center' }}>
              <strong>Mail: </strong> <a href={"mailto:" + agent.mail} style={{color: 'white', textDecoration: 'none'}}>{agent.mail}</a>
            </p>
            <p style={{ textAlign: 'center' }}><strong>Tel: </strong> {agent.phone}</p>
          </div>
        } />
    </div>
  )
}

export const Button = ({ghost, style, aStyle={}, href, children}) => {
  let extraStyles = {}
  return (
    <div style={{marginTop: 8}}>
      <div className="fusion-button-wrapper" style={{
        ...extraStyles,
        ...style
      }}>
        <a className="fusion-button button-flat button-round button-medium button-custom button-1" target="_self" href={href} style={{
          width: '100%',
          fontWeight: 'normal',
          background: ghost ? 'transparent' : '#034f84',
          color: ghost ? '#034f84' : 'white',
          fontSize: '0.8em',
          paddingLeft: 2,
          paddingRight: 2,
          border: '1px solid #034f84',
          ...aStyle}}>
          {children}
        </a>
      </div>
    </div>
  )
}


export default class ProfileInfo extends React.Component {

  render(){
    const { profile, isPDF, onProfileImageClick } = this.props
    // const imageId = profile.profileImage ? (isPDF ? profile.profilePDFImage.id : profile.profileImage.id) : null
    const imageId = profile.profileImage && profile.profileImage.id
    const profileImage = baseUrl + "/" + imageId + "/thumbnail?w=240&h=340&auto"
    const name = profile.pseudoFirstName + " " + profile.pseudoLastName
    const urlName = encodeURIComponent(name);

    return (
    <div className="ac-cols">
      <div className="ac-col-one-fourth" style={{ margin: 0}}>
        <div style={{width: '100%'}}>
          <div className="imageframe-align-center" style={{ width: '100%' }}>
            <span className="fusion-imageframe imageframe-none imageframe-1 hover-type-none" style={{ width: '100%', height: '80%', overflow: 'hidden' }}>
              <img src={profileImage} alt="" 
                   onClick={onProfileImageClick}
                   className="img-responsive wp-image-1776" 
                   alt={`${name} - profile image`}
                   style={{ minWidth: '100%', cursor: 'pointer' }} />
            </span>
          </div>
        </div>
      </div>
      <div className="ac-col-one-half profile-info__column"
        style={{
          margin: 0,
          height: '100%',
          padding: '0 16px'
        }}>
            <div>
              <h3>Langues</h3>
              <div>
                {profile.languages.map(l => <Language key={l.lang.value} lang={l.lang.value} label={l.lang.label} level={l.level} />)}
              </div>
              <div dangerouslySetInnerHTML={{__html: profile.description}} />
            </div>
        </div>

        <div className="ac-col-one-fourth" style={{ margin: 0, overflow: 'auto' }}>
          <div style={{ padding: 0, overflow: 'hidden' }}>
            <Agents agents={profile.agents} />
          
            <Button href={`//www.cyrillejoubert-talents.com/pdf-profile/${profile.id}/${urlName}`}
               ghost aStyle={{padding: 0, lineHeight: '38px', letterSpacing: 0}}>
              Télécharger la fiche&nbsp;&nbsp;
                <img src="//www.cyrillejoubert-talents.com/wp-content/uploads/2016/09/picto_pdf.png" style={{display: 'inline-block', verticalAlign: 'middle'}}/>
            </Button>
            {!isPDF && <Button href="#CV" aStyle={{padding: 0, lineHeight: '38px', letterSpacing: 2}}>
              ↓&nbsp;Voir le CV&nbsp;↓
            </Button>}
            {!isPDF && profile.videos && profile.videos.length > 0 && (
              <Button href="#videos" aStyle={{padding: 0, lineHeight: '38px', letterSpacing: 2}}>
                ↓&nbsp;Voir {profile.videos.length == 1 ? "la vidéo" : "les vidéos"}&nbsp;↓
              </Button>
            )}
          </div>
        </div>
      </div>    
    )
  }
}




/** WEBPACK FOOTER **
 ** ./src/profile/ProfileInfo.js
 **/